import { Modal, ModalBody, ModalTitle } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
const AuthenticationModal = ({ onClose, show, text }) => {
    console.log('show');
    return (React.createElement(Modal, { closeButton: true, show: show, size: "small", onClose: onClose },
        React.createElement(ModalTitle, null, "Event"),
        React.createElement(ModalBody, null, text)));
};
export default AuthenticationModal;
